<template>
    <div class="flex w-full snap-x snap-proximity overflow-x-auto py-2">
        <!-- Centrado con mx-auto en un hijo flex-none, no con justify-center en
             el contenedor con scroll (recortaría la primera tarjeta al desbordar). -->
        <div class="mx-auto flex flex-none gap-4">
            <component
                :is="item.href ? 'a' : 'div'"
                v-for="item in items"
                :key="item.key"
                v-bind="linkAttrs(item)"
                class="flex flex-shrink-0 snap-center flex-col items-center gap-1.5 px-1 text-center no-underline"
                @click="onClick"
            >
                <div
                    class="overflow-hidden rounded-full border-4 border-stack-emphasis bg-stack-text shadow-sm"
                    :class="isDesktop ? 'h-36 w-36' : 'h-28 w-28'"
                >
                    <img
                        v-if="item.imageUrl"
                        :src="item.imageUrl"
                        :alt="item.imageAlt"
                        class="h-full w-full object-cover"
                    />
                    <slot v-else name="placeholder" :item="item"></slot>
                </div>
            </component>
        </div>
    </div>
</template>

<script>
export default {
    name: "SliderV1",
    props: {
        items: { type: Array, required: true },
        previewOnly: { type: Boolean, default: false },
        isDesktop: { type: Boolean, default: true }
    },
    methods: {
        linkAttrs(item) {
            return item.href
                ? { href: item.href, target: item.target, rel: item.rel }
                : {};
        },
        onClick(event) {
            if (this.previewOnly) event.preventDefault();
        }
    }
};
</script>
